'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const valueIsDefined = value => typeof value !== 'undefined';
const Nested = ({
  elements,
  children
}) => {
  const nested = elements.filter(valueIsDefined).reduceRight((acc, element) => /*#__PURE__*/React.cloneElement(element, undefined, acc), children);
  return /*#__PURE__*/React.isValidElement(nested) ? nested : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, nested);
};

exports["default"] = Nested;
